export default "__VITE_ASSET__CQ7faQUw__"